import React from 'react';
import { useDispatch } from 'react-redux';
import { favoritesAddActivity, favoritesAddExhibitor, favoritesDelActivity, favoritesDelExhibitor } from '../../store/favoritesSlice';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as iconNo } from '@fortawesome/free-regular-svg-icons';
import { faHeart as iconIn } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import './FavoritesIndicator.css';
import useFavorites from '../../hooks/useFavorites';
/**
 * Компонент оображающий положение активности или экспонента в избранном.
 * Позволяет добавить в избранное или удалить объект из избранного.
 * Используется на странице экспонента в левом блоке и на странице активности.
 */
const FavoritesIndicator = ({ type, object }) => {
	const { t } = useTranslation();
    const dispatch = useDispatch();
    const inFav = useFavorites({ type, object });
    const obj_infav = type === 'activity' ? 'favorites.activity_infav' : 'favorites.exhibitor_infav';
    const obj_nofav = type === 'activity' ? 'favorites.activity_nofav' : 'favorites.exhibitor_nofav';

    const onClick = (e) => {
        e.stopPropagation();
        if(inFav) {
            dispatch(type === 'activity' ? favoritesDelActivity(object) : favoritesDelExhibitor(object));
        } else {
            dispatch(type === 'activity' ? favoritesAddActivity(object) : favoritesAddExhibitor(object));
        }
    };

	return (
        <div className='FavoritesIndicator' onClick={e => onClick(e)}>
            <span className='icon'><FontAwesomeIcon icon={inFav ? iconIn : iconNo } fixedWidth/></span>
            <span className='text a'>{t(inFav ? obj_infav : obj_nofav)}</span>
        </div>
	);
};

FavoritesIndicator.propTypes = {
    type: PropTypes.oneOf(['activity','exhibitor']).isRequired,
    object: PropTypes.object.isRequired,
};

export default FavoritesIndicator;
